import EditAssignedModal from './EditAssignedModal'

export default EditAssignedModal
